import {
  SET_LOGIN_FLAG,
  SET_USER_DATA,
  SET_USER_AUTHTOKEN,
  SET_ROUTE_NAME,
  SET_SEARCH_TEXT,
  SET_SEARCH_LOADER,
  UPDATE_USER_DATA,
} from "../constant/actionTypes";

const initial_state = {
  loginFlag: false,
  loginUserData: null,
  authToken: null,
  routeName: null,
  searchText: null,
  searchLoader: false,
  statusFilter: "all",
  dateRangeFilter: null,
  courseAuthorFilter: "all",
  coursePriceFilter: "all",
  courseDifficultyFilter: "all",
  userCategoryFilter: "all",
  userSiteFilter: "all",
  userProgressFilter: "all",
  moduleCourseFilter: "all",
  sessionCourseFilter: "all",
  topicCourseFilter: "all",
  topicSessionFilter: "all",
  topicTypeFilter: "all",
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LOGIN_FLAG:
      return { ...state, loading: false, loginFlag: action.flag };

    case SET_USER_DATA:
      return { ...state, loading: false, loginUserData: action.userData };

    case SET_USER_AUTHTOKEN:
      return { ...state, loading: false, authToken: action.authToken };

    case SET_ROUTE_NAME:
      return { ...state, loading: false, routeName: action.routeName };

    case SET_SEARCH_TEXT:
      return { ...state, loading: false, searchText: action.searchText };

    case SET_SEARCH_LOADER:
      return { ...state, loading: false, searchLoader: action.searchLoader };

    case "SET_STATUS_FILTER":
      return { ...state, statusFilter: action.statusFilter };

    case "SET_DATE_RANGE_FILTER":
      return { ...state, dateRangeFilter: action.dateRangeFilter };

    case "SET_COURSE_AUTHOR_FILTER":
      return { ...state, courseAuthorFilter: action.courseAuthorFilter };

    case "SET_COURSE_PRICE_FILTER":
      return { ...state, coursePriceFilter: action.coursePriceFilter };

    case "SET_COURSE_DIFFICULTY_FILTER":
      return { ...state, courseDifficultyFilter: action.courseDifficultyFilter };

    case "SET_USER_CATEGORY_FILTER":
      return { ...state, userCategoryFilter: action.userCategoryFilter };

    case "SET_USER_SITE_FILTER":
      return { ...state, userSiteFilter: action.userSiteFilter };

    case "SET_USER_PROGRESS_FILTER":
      return { ...state, userProgressFilter: action.userProgressFilter };

    case "SET_MODULE_COURSE_FILTER":
      return { ...state, moduleCourseFilter: action.moduleCourseFilter };

    case "SET_SESSION_COURSE_FILTER":
      return { ...state, sessionCourseFilter: action.sessionCourseFilter };

    case "SET_TOPIC_COURSE_FILTER":
      return { ...state, topicCourseFilter: action.topicCourseFilter };

    case "SET_TOPIC_SESSION_FILTER":
      return { ...state, topicSessionFilter: action.topicSessionFilter };

    case "SET_TOPIC_TYPE_FILTER":
      return { ...state, topicTypeFilter: action.topicTypeFilter };

    case UPDATE_USER_DATA:
      state.loginUserData.first_name = action.adminUserData.first_name;
      return { ...state, loading: false, loginUserData: state.loginUserData };

    default:
      return { ...state };
  }
};
